import { TextInput } from "@mantine/core";
import { ReactNode } from "react";

import Flex from "components/Flex";
import { commonStyles } from "components/common/styles";

export type SsnProps =  {
  onChange: (value: string) => void
  label?: ReactNode;
  description?: ReactNode;
  placeholder?: string;
  name: string;
  value?: string;
  isValid: boolean;
};

export const NameInput = ({
  onChange,
  name,
  label,
  description,
  value,
  placeholder,
  isValid,
}: SsnProps) => {
  const { classes } = commonStyles();
  return (
    <Flex gap={16}>
      <Flex gap={4}>
        <TextInput
          name={name}
          placeholder={placeholder}
          description={description}
          label={label}
          size="xl"
          value={value}
          onChange={e => onChange ? onChange(e.currentTarget.value) : null}
          classNames={{ input: (isValid ? classes.input : classes.inputErr) }}
        />
      </Flex>
    </Flex>
    
  );
};
